import { css } from "@emotion/react";
import { Edit } from "@refinedev/antd";
import { CrudCollapseStyle } from "@src/components/crud-collapse-style";
import { ButtonBackToListing } from "@src/components/crud-explore/button-back-to-listing";
import { CrudPermissionLayout } from "@src/components/crud-permission-layout";
import { Spin } from "antd";
import { PropsWithChildren } from "react";

export const LayoutWrapper: React.FC<
    PropsWithChildren<{
        headerActions: React.ReactNode;
        title: React.ReactNode;
        loading: boolean;
        isDisabled: boolean;
    }>
> = ({ children, headerActions, title, loading, isDisabled }) => {
    return (
        <Spin spinning={loading}>
            <CrudCollapseStyle>
                <CrudPermissionLayout isDisabled={isDisabled}>
                    <div
                        css={css`
                            .ant-page-header-heading {
                                padding-right: 24px;
                                padding-left: 18px;
                            }
                        `}
                    >
                        <Edit
                            breadcrumb={false}
                            title={
                                <div className="flex items-center gap-2">
                                    <ButtonBackToListing />
                                    {title}
                                </div>
                            }
                            headerButtons={<div>{headerActions}</div>}
                            saveButtonProps={{
                                className: "hidden",
                            }}
                            contentProps={{
                                style: {
                                    backgroundColor: "transparent",
                                    boxShadow: "none",
                                    paddingTop: 0,
                                },
                                styles: {
                                    body: {
                                        paddingTop: 0,
                                    },
                                },
                            }}
                        >
                            {children}
                        </Edit>
                    </div>
                </CrudPermissionLayout>
            </CrudCollapseStyle>
        </Spin>
    );
};
